import {
  CompletePaymentTransactionFragment,
  Maybe,
  useGetPaymentTransactionQuery,
} from 'drycut-graphql';
import { Link, useNavigate, useParams } from 'react-router';
import { ActionButtons, Button, Heading, Loader, Para, Stack } from 'ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function PassPurchaseError(): React.ReactNode {
  useDocumentTitle('DRYCUT - Pass payment error');

  const { transactionId } = useParams() as { transactionId: string };
  const { data, loading } = useGetPaymentTransactionQuery({
    variables: { paymentTransactionId: transactionId },
  });
  const navigate = useNavigate();

  const transaction: Maybe<CompletePaymentTransactionFragment> = data?.paymentTransaction || null;

  if (loading) {
    return <Loader />;
  }

  if (!transaction) {
    navigate('/not-found');
    return null;
  }

  return (
    <Stack gap={6} className="text-pretty text-center">
      <Heading>Oops,</Heading>
      <Heading variant="h4" className="font-aribau text-2xl">
        da ist etwas schief gegangen...
      </Heading>

      <Stack gap={2}>
        <Para>
          Sorry {transaction.data?.customerName}, Dein DRYPASS Kauf konnte nicht abgeschlossen
          werden.
        </Para>
        <Para>Aber keine Sorge, Dir wurde nichts abgebucht.</Para>
      </Stack>

      <ActionButtons>
        <Button as={Link} to="/passes">
          Versuche es nochmal
        </Button>
      </ActionButtons>
    </Stack>
  );
}
